module.exports = __webpack_public_path__ + "static/media/achievement-19.36cef57e.png";